import { createAsyncThunk } from '@reduxjs/toolkit';
import { dataFieldsService, FieldType } from '../../../../services';

export const collectionDetailsActions = {
  getDataFields: createAsyncThunk(
    'CollectionDetailsActions/GetDataFields',
    async (
      { shopId, fieldType = FieldType.CatalogField }: { shopId: number; fieldType?: FieldType },
      { rejectWithValue }
    ) => {
      try {
        const dataFields = await dataFieldsService.getDataFields({ shopId, fieldType });
        return { dataFields };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
};
